





























































































































































































import { LANGUAGE_MENU } from '@/constants/language-menu.constant';
import { TOP_MENU } from '@/constants/top-menu.constant';
import { setLanguage } from '@/i18n';
import { ICurrency } from '@resclick/data-access';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Mutation, State } from 'vuex-class';
import AppHeaderMenu from './AppHeaderMenu.vue';

@Component({
  components: { AppHeaderMenu },
})
export default class AppHeader extends Vue {
  @Mutation('auth/LOGOUT') logout!: () => void;
  @State('user') user!: any;
  @Action('user/updateProfile') updateProfile!: any;

  drawerRight = false;

  currencies: ICurrency[] = [];

  get currency() {
    return this.user.preferences?.currency || 'USD';
  }

  set currency(value: string) {
    this.updateProfile({
      preferences: { locale: this.user?.preferences?.locale, currency: value },
    });
  }

  get currencyOptions() {
    return this.currencies.map((currency) => {
      return {
        label: currency.name,
        value: currency.code,
      };
    });
  }

  get menu() {
    return TOP_MENU;
  }

  get languageMenu() {
    return LANGUAGE_MENU;
  }

  get currentLang() {
    return LANGUAGE_MENU.find((lang) => this.$i18n.locale === lang.iso);
  }

  onLangChange(lang: string) {
    setLanguage(lang);
    this.updateProfile({
      preferences: { locale: lang, currency: this.currency },
    });
  }

  onLogout() {
    this.logout();
    this.$router.push('/login');
  }

  created() {
    this.$getCrsList('currencies', 'find', {}).then((res) => {
      this.currencies = res;
    });
  }
}
